import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const StopwatchFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.5 -9.53674e-07V1.84H9.5V-9.53674e-07H14.5ZM12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C13.96 3.18 15.78 3.84 17.26 4.94L18.68 3.52L20 4.84L18.64 6.2C19.98 7.76 20.82 9.78 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM11.08 13.34H12.92V7.14H11.08V13.34Z" />
    </SvgIcon>
  );
});
